import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'fill'
})
export class FillPipe implements PipeTransform {
	transform(value) {
		if (typeof (value) != 'number')
			value = parseInt(value);
		return new Array(value).fill(1);
	}
}